<div class="scope-row flex items-center flex-col">
  <div
    class="scope-row-content flex items-center"
    (click)="selectDepartment(department.id)">
    <div
      class="column level-{{ level }} flex items-center"
      [ngClass]="config?.componentMainColumnClass">
      <mat-icon
        class="material-symbols-rounded arrow orange"
        [class.active]="scopeElementsService.departmentStates.selected[department.id]">
        expand_more
      </mat-icon>
      <commentable
        [c-root-entity]="component"
        [c-entity]="department"
        c-key="name"
        c-type="department"
        class="pl-1">
        {{ department.name }}
      </commentable>
    </div>
    <div
      class="column one--column"
      [hidden]="config?.isTimeline || !config?.scopeVersion.isScopeByScenario()"></div>
    <div
      class="column one--column"
      [hidden]="!config?.userColumns.QUANTITY?.selected"></div>
    <div
      class="column one--column"
      [hidden]="!isPreferenceActive(config?.userColumns.START_DATE)"></div>
    <div
      class="column one--column"
      [hidden]="!isPreferenceActive(config?.userColumns.END_DATE)"></div>
    <div
      class="column one--column"
      [hidden]="!config?.userColumns.MARK_UP?.selected"></div>
    <div
      class="column one--column"
      [hidden]="config?.isTimeline"></div>
    <div
      class="column one--column"
      [hidden]="!config?.userColumns.SCOPEMARK_HOURS?.selected">
      <commentable
        [c-root-entity]="component"
        [c-entity]="department"
        c-key="scopeMarkHours"
        c-type="department">
        {{ department.totalScopeMarkHours() | formatHours }}
      </commentable>
    </div>
    <div
      class="column one--column"
      [hidden]="!config?.userColumns.SCOPEMARK_PRICE?.selected">
      <commentable
        [c-root-entity]="component"
        [c-entity]="department"
        c-key="scopeMarkSellingPrice"
        c-type="department">
        {{
          department.totalScopeMarkSellingPrice()
            ? (department.totalScopeMarkSellingPrice().amount | convertCurrency: config?.currency)
            : '--'
        }}
      </commentable>
    </div>
    <div
      class="column {{ config?.isTimeline ? 'three--columns' : 'one--column' }}"
      [hidden]="!config?.isTimeline && !config?.userColumns.AGENCY_HOURS?.selected">
      <commentable
        [c-root-entity]="component"
        [c-entity]="department"
        c-key="rateCardHours"
        c-type="department">
        {{ department.getTotalRateCardHours() | formatHours }}
      </commentable>
    </div>
    <div
      class="column one--column"
      [hidden]="config?.isTimeline || !config?.scopeVersion.isScopeByScenario()"></div>
    <div
      class="column {{ config?.isTimeline ? 'three--columns' : 'one--column' }}"
      [hidden]="!config?.isTimeline && !config?.userColumns.AGENCY_PRICE?.selected">
      <commentable
        [c-root-entity]="component"
        [c-entity]="department"
        c-key="agencySellingPrice"
        c-type="department">
        {{
          department.getTotalSellingPrice({ markup: component.costPlusValue })
            ? (department.getTotalSellingPrice({ markup: component.costPlusValue }).amount
              | convertCurrency: config?.currency)
            : '--'
        }}
      </commentable>
    </div>
    <div
      [hidden]="!config?.showActionsColumn"
      class="column one--column"></div>
  </div>

  <scope-roles
    *ngIf="scopeElementsService.departmentStates.selected[department.id]"
    [level]="level + 1"
    [config]="config"
    [component]="component"
    [department]="department"
    (onOverrideRateCardRoleHours)="onOverrideRateCardRoleHours.emit($event)"
    (onUpdateRole)="onUpdateRole.emit($event)">
  </scope-roles>
</div>
